// extracted by css-extract-rspack-plugin
var _1 = "PressTip-m_arrow-qrCkcWym";
var _2 = "PressTip-m_content-U0ybf7MG";
var _3 = "PressTip-m_control-JcXmq7TF";
var _4 = "PressTip-m_header-w1l90OtE";
var _5 = "PressTip-m_minimalTooltip-SO6eEqfl";
var _6 = "PressTip-m_section-MNfYMJ_N";
var _7 = "PressTip-m_tooltip-SHtI4cRc";
var _8 = "PressTip-m_wideTooltip-edAAXFfv";
export { _1 as "arrow", _2 as "content", _3 as "control", _4 as "header", _5 as "minimalTooltip", _6 as "section", _7 as "tooltip", _8 as "wideTooltip" }
